// extracted by mini-css-extract-plugin
export default {"wrapper":"ag98t6urquSWmHfXEaDQ","freezeBtn":"D7Y8QrOtp2KaHYClYqHv"};